// MathRods-specific Make/Play contract. No shared editor or Lambda changes.
export const problemsPath = versionType => versionType ? `${versionType}.problems` : 'problems';
export const contentForVersion = (data, versionType = '') => versionType ? data?.languageVersionData?.[versionType] : data?.gameData;

// Older authored explanations may be missing fields added in later MathRods
// revisions. Fill only absent structural defaults in memory, never rewrite the
// author's original saved document or accept an incomplete question as valid.
export function compatibleExplanation(segment) {
  if (!segment || segment.type !== 'explanation') return segment;
  return {
    ...segment,
    setup: Array.isArray(segment.setup) ? segment.setup : [],
    answer: Array.isArray(segment.answer) ? segment.answer : [],
    choices: Array.isArray(segment.choices) ? segment.choices : ['', ''],
    demo: Array.isArray(segment.demo) ? segment.demo : [],
  };
}
export function isPlayableMathRodsSegment(segment, validateSegment) {
  return Boolean(segment && validateSegment(compatibleExplanation(segment)));
}
export const anySegmentReady = (data, validateSegment) => {
  const ready = content => Array.isArray(content?.problems)
    && content.problems.some(segment => isPlayableMathRodsSegment(segment, validateSegment));
  return ready(data?.gameData) || Object.values(data?.languageVersionData || {}).some(ready);
};
export const playableContent = (data, versionType, validateSegment) => {
  const content = contentForVersion(data, versionType) || {};
  return {
    ...content,
    problems: Array.isArray(content.problems)
      ? content.problems.filter(segment => isPlayableMathRodsSegment(segment, validateSegment))
        .map(segment => validateSegment(segment) ? segment : compatibleExplanation(segment))
      : [],
  };
};
export const authoringUpdates = (value, versionType = '') => ['problems', 'options', 'helpText']
  .filter(key => value[key] !== undefined).map(key => [versionType ? `${versionType}.${key}` : key, value[key]]);
